import { UAParser } from "ua-parser-js";
import { cyrb53 } from "./hash";

// Small fixed dictionaries (subset of unique-names-generator colors/animals).
const COLORS = ["Amber","Azure","Blue","Bronze","Coral","Crimson","Cyan","Emerald","Golden","Green",
  "Indigo","Ivory","Jade","Lime","Magenta","Maroon","Navy","Olive","Orange","Pink",
  "Purple","Red","Ruby","Scarlet","Silver","Teal","Violet","White","Yellow","Cobalt"];
const ANIMALS = ["Fox","Cat","Wolf","Bear","Hawk","Otter","Lynx","Panda","Tiger","Eagle",
  "Shark","Whale","Falcon","Moose","Bison","Heron","Raven","Koala","Lemur","Gecko",
  "Puma","Crane","Ibex","Mantis","Newt","Quail","Robin","Seal","Toad","Viper"];

function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function generateDisplayName(peerId: string): string {
  const seed = cyrb53(peerId);
  const color = COLORS[seed % COLORS.length];
  const animal = ANIMALS[Math.floor(seed / COLORS.length) % ANIMALS.length];
  return `${capitalize(color)} ${capitalize(animal)}`;
}

export function deviceNameFromUA(ua: string): string {
  if (typeof ua !== "string" || !ua.trim()) return "Unknown Device";
  const p = new UAParser(ua).getResult();
  let name = "";
  if (p.os && p.os.name) name = p.os.name.replace("Mac OS", "Mac") + " ";
  name += p.device && p.device.model ? p.device.model : (p.browser && p.browser.name) || "";
  return name.trim() || "Unknown Device";
}
